import React from 'react';

import IconFont from '../IconFont';
import { StyledDialog, CloseButton } from './Modal.styles';

const Modal = ({
  onClose, isOpen, children, height, width
}) => (
  <StyledDialog
    open={isOpen}
    onClose={onClose}
    height={height}
    width={width}
    scroll="paper"
  >
    <CloseButton title="Cerrar" contentColor="primary" bgColor="none" onClick={onClose} alt="Cerrar">
      <IconFont className="icon-close" size={1.4} />
    </CloseButton>
    {children}
  </StyledDialog>
);

export default Modal;
